<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

@if (model$ | async) {
    <div class="modal-body">
        <table class="data-grid">
            <thead class="daily-count-tbl">
                <th>Name of Holiday</th>
                <th>Day of Holiday</th>
                <th>Day Observed</th>
            </thead>
            <tbody>
                @for (o of model.holidays; track o) {
                    <tr>
                        <td>{{ o.holidayName }}</td>
                        <td>{{ o.holidayDate | date: 'longDate' }}</td>
                        <td>{{ o.observedDate | date: 'longDate' }}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
